import { cn } from "@omni/utils/styles";
import { CountryCode } from "libphonenumber-js";
import { Fragment } from "react";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { StoreDistanceComponent } from "@/components/Store/shared/storeDistance/storeDistance.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StoreStatus } from "./storeStatus/storeStatus.component";

type StoreCardProps = {
    className?: string;
    isSelected?: boolean;
    isOpen: boolean;
    openClosesAt?: string;
    handleOnStoreCardClick?: () => void;
    name: string;
    distancePromise?: Promise<undefined | number>;
    addressLines: Array<string>;
    phone: string;
    countryCode?: CountryCode;
};

const StoreCard = ({
    className,
    isSelected,
    isOpen,
    openClosesAt,
    handleOnStoreCardClick,
    name,
    distancePromise,
    addressLines,
    phone,
    countryCode
}: StoreCardProps) => {
    const { t } = useGranite();

    const statusText = t(
        `form.searchstore.storeCard.status.${isOpen ? "open" : "closed"}`
    );

    return (
        <li
            className={cn(
                "tw:p-2 tw:flex tw:flex-col tw:relative tw:overflow-hidden tw:min-h-33.75",
                {
                    "tw:bg-grey": isSelected,
                    "tw:border tw:border-grey-input tw:cursor-pointer tw:rounded-md tw:hover:bg-grey":
                        !!handleOnStoreCardClick
                },
                className
            )}
            onClick={handleOnStoreCardClick}
        >
            <p className={cn("tw:font-bold tw:text-xl")}>
                {name}
                {distancePromise && (
                    <StoreDistanceComponent distancePromise={distancePromise} />
                )}
            </p>
            <StoreStatus
                isOpen={isOpen}
                openClosesAt={openClosesAt}
                statusText={statusText}
            />
            <p className={cn("tw:mb-2")}>
                {addressLines.map((line, index) => {
                    return (
                        <Fragment key={index}>
                            <span>{line}</span>
                            {index < addressLines.length - 1 && <br />}
                        </Fragment>
                    );
                })}
            </p>
            <p className={cn("tw:w-auto tw:mb-2")}>
                <PhoneNumber
                    phoneNumber={phone}
                    ISOcountryCode={countryCode}
                    asLink={true}
                />
            </p>
        </li>
    );
};

export { StoreCard };
